module.exports = __webpack_public_path__ + "static/img_4642-cecf500df5b2b96e5b4930337383cec1.webp";